export const QUERY_STRING = {
  ACTION: 'action',
  ACTION_PLAN_ID: 'actionPlanId',
  ACTION_PLAN_TASK_ID: 'taskId',
  ACTION_PLAN_TASK_MSG_ID: 'messageId',
  AUDIENCE: 'audience',
  BACK: 'back',
  CALLAISHARE: 'callaishare',
  CONTACT_ID: 'cid',
  CONTENTS: 'contents',
  DEAL_ID: 'did',
  DEAL_NAME: 'dn',
  DOWNLOAD_SIGNABLE_ID: 'dsid',
  EMAIL: 'email',
  ERROR_MESSAGE: 'errmsg',
  FOR_PARTNER_USE: 'forPartnerUse',
  GUEST_ID: 'gid',
  GUEST_PROVIDE_ACCESS: 'gpa',
  IGNORE_CONTENT_PREPARED: 'icp',
  TOAST: 'toast',
  CRM_ID: 'crmId',
  CRM_NAME: 'crmName',

  // library filters
  FILTER_PAGE: 'page',
  FILTER_PENDING_REVIEW: 'pendingReview',
  FILTER_RESULTS: 'resultsPerPage',
  FILTER_SEARCH: 'search',
  FILTER_SHAREABILITY: 'shareability',
  FILTER_SHOW_SELECTED: 'showSelected',
  FILTER_SORT: 'sort',
  FILTER_SYNC_OPTIONS: 'syncOptions',
  FILTER_TAGS: 'tags',
  FILTER_USERS: 'users',
  FILTER_VISIBILITY: 'visibility',

  // common
  COMPANY: 'company',
  INTERCOM_TOUR_ID: 'product_tour_id',
  IS_DSR_PICKER: 'is_dsr_picker',
  IS_INTERNAL_DSR: 'isInternalDSR',
  MAP_ID: 'mapId',
  MEETING_ID: 'mid',
  NEXT: 'next',
  PLAN_FREQUENCY: 'pfq',
  PLAN_NAME: 'pnm',
  PLAN_UUID: 'puuid',
  PROVIDE_ANOTHER_REFERENCE: 'pa',
  PROVIDER: 'provider', // ott provider
  REFERRER: 'ref',
  RESET_QUERY: 'reset',
  ROOM_ACTION: 'action',
  ROOM_CONTACT_TOKEN: 'rct',
  ROOM_MESSAGE_ID: 'rmid',
  ROOM_NAME: 'rn',
  ROOM_OWNER: 'owner',
  ROOM_SCOPE: 'scope',
  ROOM_STATUS: 'status',
  ROOM_SESSION_ID: 'rsid',
  ROOM_TEMPLATE_ID: 'rtid',
  ROOM_UUID: 'uuid',
  SEARCH: 's',
  SECTION: 'section',
  SIGN_IN: 'signIn',
  SIGN_OUT: 'signOut',
  SIGNABLE_ID: 'signableId',
  SORT_ORDER: 'sortOrder',
  SORT: 'sort',
  STEP: 'step',
  SUCCESS_INTEGRATION_ID: 'siid',
  SUCCESS: 'success',
  TEMPLATE: 'template',
  TOKEN: 'token', // ott
  UPGRADE: 'upgrade',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_CONTENT: 'utm_content',
  UTM_MEDIUM: 'utm_medium',
  UTM_SOURCE: 'utm_source',
  UTM_TERM: 'utm_term',
};
